import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AzureSsoService } from './azure-sso.service';

@NgModule({
  providers: [
    AzureSsoService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class AzureSsoModule {}
